import { RefObject, useEffect, useRef } from "react";
import { changeAppState } from "../../../../../../common/appState";
import { relativeScroll } from "../../../../../../common/util/Scroll/relativeScroll";
import "../style.css";
import { InitialView } from "./types";

export function useScrollToMyPageItem<T extends HTMLElement>({
    scrollableContainerRef,
    initialView,
    itemName,
}: {
    scrollableContainerRef: RefObject<HTMLDivElement>;
    initialView?: InitialView;
    itemName: InitialView;
}) {
    const scrollTargetRef = useRef<T>(null);
    const scrollToThisArea = () => {
        if (!scrollTargetRef.current || !scrollableContainerRef.current) {
            setTimeout(scrollToThisArea, 200);
            return;
        }
        relativeScroll(
            scrollableContainerRef.current,
            scrollTargetRef.current,
            10
        );
    };

    const initiallyOpen = initialView === itemName;
    useEffect(() => {
        if (!initiallyOpen) {
            return;
        }
        scrollToThisArea();
        changeAppState("signInPanelState", {
            type: "myPageTop",
        });
    }, [initiallyOpen]);

    return { scrollTargetRef };
}
